module.exports = __webpack_public_path__ + "img/dummy-avatar.0474e8fe.png";